<template>
  <modal 
    name="suspended-modal" 
    :pivotY="0.2"
    :height="'auto'"
    width="90%" :maxWidth="550" :adaptive="true">
    
    <div class="modal-header">
      <div class="modal-title">
        This feature is available for Standard &amp; Pro plans
      </div>

      <a href="#"
        v-on:click.prevent="$modal.hide('suspended-modal')"
        class="text-gray-500 hover:text-gray-600">
        <svg width="20" height="20" stroke-width="2" stroke="currentColor" fill="none">
          <use xlink:href="/static/img/feather-sprite.svg#x-circle"/>
        </svg>
      </a>
    </div>
    
    <div class="modal-body">

      <div class="text-base leading-normal">
        You are currently on Free Plan and the feature that you are trying to access is only available on 
        our Standard or Pro plans. Please upgrade your plan in order to activate this feature.
      </div>

      <div class="mt-8 text-left">
        <SubmitButton label="Got it!" :onClick="submit" />
      </div>

    </div>
  </modal>
</template>

<script>
  import SubmitButton from '@/shared/components/form/SubmitButton'

  export default {

    components : {
      SubmitButton
    },

    methods : {
      submit() {
        this.$modal.hide('suspended-modal')
        this.$router.push({
          name   : 'broker-payment', 
          params : {
            brokerId : this.$store.state[this.$store.state.view + 'Module'].broker.id
          }
        })
      }
    }
  }
</script>